































import Vue from 'vue';

import ShowCardItem from './show-card-item.vue';
import { IShow } from '../../../types';

export default Vue.extend({
  name: 'ShowCards',

  components: {
    ShowCardItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    shows: {
      type: Array,
      default: () => [],
    },

    rows: {
      type: Boolean,
      default: true,
    },

    limit: {
      type: Number,
      default: 0,
    },

    randomize: {
      type: Boolean,
      default: false,
    },

    saved: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    editedShows: [] as Record<string, any>[],
  }),

  created() {
    this.editedShows = [] as Record<string, any>[];

    for (let i = 0; i < this.shows.length; i += 1) {
      this.editedShows.push((this.shows[i] as Record<string, any>[]));
    }

    if (this.randomize) {
      this.editedShows = this.editedShows.sort(() => 0.5 - Math.random());
    }

    if (this.limit !== 0) {
      this.editedShows.length = this.limit;
    }
  },

  methods: {
    unlike(id: number) {
      const newShows = [];

      for (let i = 0; i < this.editedShows.length; i += 1) {
        if (i !== id) {
          newShows.push(this.editedShows[i]);
        }
      }

      this.editedShows = newShows as IShow[];
    },
  },
});
